import VerifyDocumentCredabilityActionTypes from './verify-document-credability.types'

const verifyDocumentCredabilityReducer = (state=null, action) => {
  
  switch (action.type) {
    case VerifyDocumentCredabilityActionTypes.VERIFY_DOCUMENT_CREDABILITY_SUCCESS:
       return {
        ...state,
        ...action.payload
       }
    default:
      return state
  }
}

export default verifyDocumentCredabilityReducer